import { FormattedAssignment } from 'modules/cost_centers/components/CostCenterAssigments/lib/types'

import { DEFAULT_ASSIGNMENT_COST_CENTER_ID, DEFAULT_ASSIGNMENT_PERCENTAGE } from './defaults'

export const totalDedication = (assignments: FormattedAssignment[]) => {
  return (
    assignments.reduce(
      (acc, cur) => acc + (cur.percentage === DEFAULT_ASSIGNMENT_PERCENTAGE ? 0 : cur.percentage),
      0
    ) * 100
  ).toFixed(2)
}

export const validDedication = (assignments: FormattedAssignment[]) => {
  return totalDedication(assignments) === '100.00'
}

export const hasZeroDedication = (assignments: FormattedAssignment[]) => {
  return !!assignments.find(
    (a) => a.percentage === 0 || a.percentage === DEFAULT_ASSIGNMENT_PERCENTAGE
  )
}

/**
 * Check if any assignment has an unassigned cost center
 * Legacy mode: costCenterId <= -1 means unassigned
 * Structured mode: both jobCatalogCostCenterId and workplaceCostCenterId are undefined/null means unassigned
 */
export const hasUnassignedCostCenter = (
  assignments: FormattedAssignment[],
  hasNewStructureEnabled = false
) => {
  if (hasNewStructureEnabled) {
    // In structured mode, at least one of jobCatalogCostCenterId or workplaceCostCenterId must be set
    return !!assignments.find(
      (a) => a.jobCatalogCostCenterId == null && a.workplaceCostCenterId == null
    )
  }
  // Legacy mode
  return !!assignments.find(
    (a) => a?.costCenterId && a.costCenterId <= DEFAULT_ASSIGNMENT_COST_CENTER_ID
  )
}
